<script lang="ts">
    import "./sub/inputStyle.css";

    interface AvalibleRec<T> {
        name: string;
        value: T;
    }
    interface DisplayedAvalibleRec<T> extends AvalibleRec<T> {
        prefix: string;
        sufix: string;
    }

    export let name;
    export let optionsList: AvalibleRec<any>[] = [];
    export let inputValue: string = "";
    export let value: any = null;
    export let required: boolean = false;

    let labelIsUp = false;
    let err_notFound = false;
    let err_required = false;
    let errActive = false;
    $: errActive = err_notFound || err_required;

    let nativeInput = null;
    let avalibleSorted: AvalibleRec<any>[] = [];
    let displayedAvalible: DisplayedAvalibleRec<any>[] = [];
    let avalibleSorted_reverse: AvalibleRec<any>[] = [];
    $: sortAvalible(optionsList);
    function sortAvalible(list: AvalibleRec<any>[]) {
        const sortedList = list
            .map((val) => ({
                name: val.name.toLowerCase(),
                value: val.value,
            }))
            .sort((a, b) => {
                if (a.name.length === b.name.length) {
                    return a.name.localeCompare(b.name);
                }
                return a.name.length - b.name.length;
            });
        avalibleSorted = sortedList;
        /* avalibleSorted = sortedList.filter((val) =>
            inputValue.length < val.name.length
                ? false
                : inputValue === val.name.substring(0, inputValue.length)
        ); */
        avalibleSorted_reverse = [...sortedList];
        avalibleSorted_reverse.reverse();
        updateState();
    }

    let nextText = "";
    function updateState() {
        focusedElement = -1;
        if (!nativeInput || !inputValue) {
            resetSelected();
            labelIsUp = false;
            displayedAvalible = avalibleSorted.map((val) => {
                return {
                    name: val.name,
                    value: val.value,
                    prefix: "",
                    sufix: val.name,
                };
            });
            if (required) {
                err_required = true;
            }
            return;
        }
        labelIsUp = true;
        err_required = false;

        displayedAvalible = avalibleSorted
            .filter((val) => {
                return inputValue.length > val.name.length
                    ? false
                    : inputValue === val.name.substring(0, inputValue.length);
            })
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((val) => {
                return {
                    name: val.name,
                    value: val.value,
                    prefix: val.name.substring(0, inputValue.length),
                    sufix: val.name.substring(inputValue.length),
                };
            });
        // return;

        if (
            displayedAvalible.length !== 0 &&
            displayedAvalible[0].name === inputValue
        ) {
            err_notFound = false;
            value = displayedAvalible[0].value;
            // setEntity(displayedAvalible[0]);
        } else {
            err_notFound = true;
            resetSelected();
            return;
        }

        /* const nextValIndex = avalibleSorted_reverse.findIndex((val) =>
            inputValue.length < val.name.length
                ? false
                : inputValue === val.name.substring(0, inputValue.length)
        );
        console.log(inputValue, nextValIndex, avalibleSorted_reverse);
        if (nextValIndex < 0) {
            err_notFound = true;
            resetSelected();
            return;
        }
        err_notFound = false;
        const targetVal = avalibleSorted_reverse[nextValIndex];
        nextText = targetVal.name;
        if (targetVal.name === inputValue) {
            value = targetVal.value;
        } else {
            value = null;
        } */
    }

    function setEntity(entyty: AvalibleRec<any>) {
        inputValue = entyty.name;
        showTable = false;
        updateState(); /* TODO */
    }

    function resetSelected() {
        nextText = "";
        value = null;
    }

    function handleKeyup(event) {
        if (event.code === "Enter") {
            event.preventDefault();
            if (displayedAvalible.length !== 0) {
                const trgIndex = focusedElement < 0 ? 0 : focusedElement;
                setEntity(displayedAvalible[trgIndex]);
            }
        } else if (
            event.code === "ArrowDown" &&
            focusedElement < displayedAvalible.length - 1
        ) {
            focusedElement = focusedElement + 1;
        } else if (event.code === "ArrowUp" && focusedElement > 0) {
            focusedElement = focusedElement - 1;
        }
    }

    let focusedElement = -1;
    let showTable = false;
    /* let disableShow = false;
    function disableBlur() {
        disableShow = true;
    } */
    function setAbsTrgEntryIndex(trgIndex) {
        focusedElement = trgIndex;
    }
    function onFocus() {
        showTable = true;
    }
    function onBlur() {
        setTimeout(() => {
            showTable = false;
        }, 220);
        focusedElement = -1;
    }
</script>

<div class="root">
    <div class="textBlock">
        <span class="standartLabel" class:inputLabelUp={labelIsUp}>{name}</span>
        <input
            class="inputRectangle"
            bind:this={nativeInput}
            bind:value={inputValue}
            on:input={updateState}
            on:blur={() => onBlur()}
            on:focus={() => onFocus()}
            on:keyup|preventDefault={handleKeyup}
            type="text"
            {required}
        />
        <!-- <span class="nextText">{nextText}</span> -->
        <div class="underline">
            <div
                class="underlineColor focusColorLine"
                style="background: var(--prim);"
            />
            <div
                class="underlineColor"
                class:errBackgorundActive={errActive}
                style=" background: var(--err);"
            />
        </div>
        <div class="optionAncor">
            <div class="oprionWrap" style={showTable ? "display: block;" : ""}>
                {#each displayedAvalible as value, i}
                    <div
                        on:mouseover={() => setAbsTrgEntryIndex(i)}
                        on:click={() => setEntity(value)}
                        class:focusedEntry={i === focusedElement}
                    >
                        <span style="font-weight: 500;">{value.prefix}</span>
                        <span>{value.sufix}</span>
                        <!-- <span>{value.name}</span> -->
                    </div>
                {/each}
            </div>
        </div>
    </div>
    {#if err_required}
        <div class="errorBlock">
            <!-- transition:fade={{ duration: 400 }} -->
            <p>Pole je <strong>povinné</strong>.</p>
        </div>
    {/if}
    {#if err_notFound}
        <div class="errorBlock">
            <!-- transition:fade={{ duration: 400 }} -->
            <p>Neznámá entita.</p>
        </div>
    {/if}
</div>

<style>
    .root {
        /* padding: 0.2rem 2rem 1rem 2rem; */
        box-sizing: border-box;
        background: var(--back);
        display: flex;
        flex-direction: column;
    }
    .standartLabel {
        align-self: start;
        margin: 0 0.5rem;
        bottom: -1.7rem;
    }
    .nextText {
        position: absolute;
        color: var(--back_D15);
        font-size: 0.9rem;
    }
    .optionAncor {
        position: relative;
        /* top: -0.6rem;  */
    }
    .oprionWrap {
        display: none;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        max-height: 15rem;
        background: white;
        overflow-y: scroll;
        z-index: 100;
        border: solid 1px black;
        border-top: none;
        margin: 0;
        padding: 0;
        /* box-shadow: 1px ; */
    }
    .oprionWrap > div {
        padding: 4px 0.8em;
        font-weight: 300;
        color: var(--back_D2);
        display: flex;
    }
    /* .oprionWrap > div:hover {
        background: var(--back_D12);
    } */
    .focusedEntry {
        background: var(--back_D12);
    }
    /*  .textBlock:focus-within .oprionWrap {
        display: block;
    } */

    .errBackgorundActive {
        width: 100%;
    }
</style>
